import { forwardRef } from "react";
import type { HTMLAttributes, ReactNode } from "react";
import "./Toast.css";

export type ToastTone = "success" | "error" | "info" | "attention" | "warning";

export interface ToastProps extends HTMLAttributes<HTMLDivElement> {
  tone?: ToastTone;
  icon?: ReactNode;
  onDismiss?: () => void;
  dismissLabel?: string;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const Toast = forwardRef<HTMLDivElement, ToastProps>(function Toast(
  {
    tone = "info",
    icon,
    onDismiss,
    dismissLabel = "Dismiss",
    className,
    children,
    role = "status",
    ...rest
  },
  ref,
) {
  return (
    <div
      ref={ref}
      role={role}
      className={cx("go4-toast", `go4-toast--${tone}`, className)}
      {...rest}
    >
      {icon ? <span className="go4-toast__icon">{icon}</span> : null}
      <span className="go4-toast__message">{children}</span>
      {onDismiss ? (
        <button
          type="button"
          aria-label={dismissLabel}
          className="go4-toast__dismiss"
          onClick={onDismiss}
        >
          <CloseIcon />
        </button>
      ) : null}
    </div>
  );
});
